import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    Container,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap";
import API from "../../utils/API";
import Select from "react-select";

const UrlCloneTool = () => {
    const [sources, setSources] = useState([]);
    const [publishers, setPublishers] = useState([]);
    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedPublisher, setSelectedPublisher] = useState(null);
    const [generatedUrl, setGeneratedUrl] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch sources
        API.get('/admin/leadsource').then((response) => {
            const sourceData = response.data.data || [];
            const sourceOptions = sourceData.map((source) => ({
                value: source.id,
                label: `${source.title} (${source.url || 'No URL'})`,
                url: source.url
            }));
            setSources(sourceOptions);
        }).catch((error) => {
            console.error("Error fetching sources:", error);
        });

        // Fetch publishers
        API.get("/system/publishers").then((response) => {
            const publisherData = response.data.data || [];
            const publisherOptions = publisherData.map((publisher) => ({
                value: publisher.id,
                label: `#${publisher.id}, ${publisher.name}`
            }));
            setPublishers(publisherOptions);
            setLoading(false);
        }).catch((error) => {
            console.error("Error fetching publishers:", error);
            setLoading(false);
        });
    }, []);

    const handleSourceChange = (selectedOption) => {
        setSelectedSource(selectedOption);
        generateUrl(selectedOption, selectedPublisher);
    };

    const handlePublisherChange = (selectedOption) => {
        setSelectedPublisher(selectedOption);
        generateUrl(selectedSource, selectedOption);
    };

    const generateUrl = (source, publisher) => {
        if (source && publisher && source.url) {
            const separator = source.url.includes('?') ? '&' : '?';
            const url = `${source.url}${separator}publisher_id=${publisher.value}&subid=INSERT_SUBID`;
            setGeneratedUrl(url);
        } else {
            setGeneratedUrl("");
        }
    };

    const copyToClipboard = () => {
        if (generatedUrl) {
            navigator.clipboard.writeText(generatedUrl).then(() => {
                // You could add a toast notification here if needed
            }).catch((err) => {
                console.error("Failed to copy:", err);
            });
        }
    };

    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-3">Url Clone Tool</h1>
            <Card>
                <CardBody>
                    <FormGroup>
                        <Label>Source</Label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={sources}
                            value={selectedSource}
                            onChange={handleSourceChange}
                            placeholder="Select a source"
                            isClearable
                            isLoading={loading}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Publisher</Label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={publishers}
                            value={selectedPublisher}
                            onChange={handlePublisherChange}
                            placeholder="Select a publisher"
                            isClearable
                            isLoading={loading}
                        />
                    </FormGroup>
                    {generatedUrl && (
                        <FormGroup>
                            <Label>Generated URL</Label>
                            <div className="d-flex">
                                <Input
                                    type="text"
                                    value={generatedUrl}
                                    readOnly
                                    className="mr-2"
                                />
                                <Button color="primary" onClick={copyToClipboard}>
                                    Copy
                                </Button>
                            </div>
                        </FormGroup>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
};

export default UrlCloneTool;
